import IOverrideAvatarOption from "@core-shared/interfaces/IOverrideAvatarOption"; export
	default class OverrideAvatarOption implements IOverrideAvatarOption {
	useGeneratedAvatar: boolean = false; useInitials: boolean = false;
	usePhotoUrl: boolean = false;
}
